import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { ButtonGroup, Col, Row, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  AddPlusIcon,
  CancelIcon,
  CheckMarkIcon,
  DeleteDusbinIcon,
  DownloadArrowIcon,
  EditPensilIcon,
  FavoriteIcon,
  FavoriteRedIcon,
  ShareProductIcon,
  ThreeSixtyIcon,
  UploadFileIcon,
  FullScreenIcon,
  AIVideoIcon,
  ImagineLogo,
  CopyIcon,
} from '../../assets/icons';
import Logo from '../../assets/images/ImagineLogo.png';
import { Download, FooterButton, InfiniteScroll, Loader, StyledSelect } from '../../common';
import AddToCollectionPopup from '../../common/AddToCollectionPopup';
import ARViewButton from '../../common/ARViewer/ARViewButton';
import { getCategoryFields } from '../../common/EditProjectPopup/fieldsConfig';
import React360 from '../../common/React360';
import Button from '../../components/Button/Button';
import {
  MODEL_TYPES,
  PRODUCT_CATEGORY_VALUE,
  PRODUCT_DETAILS_PAGE_LABEL,
  PRODUCT_DETAILS_TAB,
  PRODUCT_FILTER_TYPE,
  RENDER_STATUS,
  REQUEST_STATUSES,
  SETTINGS_TAB,
  STATUS_DONE,
} from '../../constants/constants';
import {
  ADMIN_MY_PRODUCTS_3DMODAL,
  ADMIN_MY_PRODUCTS_3DMODAL_V2,
  ADMIN_MY_PRODUCTS_AIVIDEO_PREVIEW,
  ADMIN_SETTINGS,
  PRODUCT_360_VIEWER_PUBLIC,
  SIGN_IN_ROUTE,
  SIGNUP_ROUTE,
} from '../../constants/routePathConstants';
import {
  checkIfMemberHaveEditorAccess,
  checkIfEmailIsVerifiedOrNot,
  useUserContext,
} from '../../contexts/UserContext';
import {
  apiCreatePublicUUID,
  apiCreatePublicUUIDPublic,
  // apiGetGlobalTags,
  apiGetProp,
  apiGetPropPublicInfo,
  apiGetPublicUUID,
  apiGetPublicUUIDPublic,
  apiGetWebExperienceProductDetails,
  apiUpdateWebExperienceProductDetails,
  cancelAIVideoRender,
  createAutomaticAIVideoPreview,
  apiGetProduct360UploadImages,
  apiGetProduct360UploadImagesPublic,
  apiCheckIsPackProductViaId,
  apiGetRequest,
  apiGetPropOptimized,
  apiGetPdpProducts,
} from '../../helpers/api';
import {
  getRenderOriginalFile,
  getUrlExtension,
  handleClearWindowState,
  handleScrollPage,
  handleToggleScreen,
  isInternalUser,
  openFormInCaseOfNewOrgAndFreemiumUser,
  SortArrayBySeq,
  wait,
  windowOpen,
} from '../../helpers/jsHelper';
import { getCuratorRenderPreviewPath } from '../../helpers/urlHelper';
import { download, downloadPrepared } from '../../common/DownloadFileController/downloadFile';
import { useApi } from '../../hooks/useApi';
import { useFilterDropdownOptions } from '../../hooks/useFilterDropdownOptions';
import { useProductActions } from '../../hooks/useProductActions';
import Breadcrumbs from '../../layouts/Breadcrumbs';
import { addToCollectionActions } from '../../redux/slicers/addToCollectionPopupSlicer';
import { setTemporaryPreventBackupPopup } from '../../redux/slicers/admin/curatorSlicer';
import { sharePopupActions } from '../../redux/slicers/sharePopupSlicer';
import { UploadRenderModal } from './UploadRenderModal';
import { UploadThreeSixtyImage } from './UploadThreeSixtyImage';
import styles from '../../assets/scss/modules/_previewUI.module.scss';
import cx from 'classnames';
import { IMAGE_VARIATION_TYPE, PASS } from '../../constants/renderPreviewConstants';
import {
  AddAddonCart,
  GetAllCartProductList,
  getSubscriptionLinkedProductData,
  linkSubscriptionProductData,
  removeAllItemsFromCart,
  setClientSubscriptionPlans,
} from '../../api/subscription/subscription';
import {
  LINKED_PRODUCT_DATA,
  OFFER_PRICE_DATA,
  navigateToUpgradePlan,
} from '../subscriptionComponents/subscriptionHelper';
import { dispatcher, navigate } from '../../helpers/projectHelper';
import CartIconWhite from '../../assets/images/cart_icon_white.svg';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, EffectFade } from 'swiper';
import { MdOutlineCloseFullscreen } from 'react-icons/md';
import { usePageTitle } from '../../hooks/usePageTitle';
import { EditIcon } from '../../components/icons/EditIcon';
import ShareButton from './ShareButton';
import VariantDropdown from './VariantDropdown';
import { useCopyToClipboard } from 'react-use';
import { errorToast, infoToast, successToast, warningToast } from '../../helpers/toastHelper';
import {
  selectAddonsList,
  selectAvailable3DViewerAR,
  selectHighestPlanOrderId,
  selectUserActivePlanDetails,
  selectUserActivePlanSubscriptionOrderId,
  selectUserPlanList,
} from '../../redux/slicers/subscriptionSlicer';
import { openInfoDialog, useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { getAndSetCookieData, loadImageAsync } from '../../helpers/apiHelper';
import { ImageryShowCase } from './ImageryShowCase';
import { SilosListShowCase } from './SilosListShowCase';
import { ConfiguratorShowCase } from './ConfiguratorShowCase';
import modalStyles from '../../components/InfoDialog/InfoDialogUI.module.scss';
import CreateVideoPopUp from '../../components/AIVideoPreview/CreateVideoPopUp';
import { VideoTabShowcase } from './VideoTabShowcase';
import MenuDropdown from '../../common/MenuDropdown';
import { ROOM_TYPE } from '../../constants/roomConstants';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { Mixpanel, MxEvent } from '../../common/Mixpanel';
import {
  sendProductPageViewedData,
  shouldTrackPageViewed,
} from '../../components/EmailGating/EmailGating';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils/dist/jszip-utils';
import { PERMISSION } from '../../constants/permissionConstants';
import { useStaticPermissions } from '../../hooks/usePermissions';
import {
  selectPdpProductCountInfo,
  selectPdpProductDetails,
  setPdpProductCountInfo,
  setPdpProductDetails,
} from '../../redux/slicers/productV2Slicer';
import { isPdpProduct } from '../NewProductUIV2/ShareButtonV2/helpers';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, EffectFade]);

const imagesActionMenu = [
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.RE_ORDER_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.RE_ORDER_VALUE,
    icon: null,
    permissionsRequired: true,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_VALUE,
    icon: <UploadFileIcon />,
    permissionsRequired: true,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_GIF_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_GIF_VALUE,
    icon: <UploadFileIcon />,
    permissionsRequired: true,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_IMAGE_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_IMAGE_VALUE,
    icon: <UploadFileIcon />,
    permissionsRequired: true,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.DELETE_ALL_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.DELETE_ALL_VALUE,
    icon: <DeleteDusbinIcon />,
    permissionsRequired: true,
  },
];

const SeparateActionMenu = [
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.RENAME_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.RENAME_VALUE,
    icon: <EditIcon />,
    permissionsRequired: true,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.DOWNLOAD_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.DOWNLOAD_VALUE,
    icon: <DownloadArrowIcon />,
    permissionsRequired: false,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.EDIT_IN_3D_VALUE,
    value: PRODUCT_DETAILS_PAGE_LABEL.EDIT_IN_3D_LABEL,
    icon: <ImagineLogo />,
    permissionsRequired: false,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.COPY_EDITS_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.COPY_EDITS_VALUE,
    icon: <CopyIcon />,
    permissionsRequired: false,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.PASTE_APPLY_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.PASTE_APPLY_VALUE,
    icon: <EditIcon />,
    permissionsRequired: false,
  },
  {
    label: PRODUCT_DETAILS_PAGE_LABEL.DELETE_LABEL,
    value: PRODUCT_DETAILS_PAGE_LABEL.DELETE_VALUE,
    icon: <DeleteDusbinIcon />,
    permissionsRequired: true,
  },
];

const DoNotShowMenusInPublicPage = [
  PRODUCT_DETAILS_PAGE_LABEL.EDIT_VALUE,
  PRODUCT_DETAILS_PAGE_LABEL.DELETE_VALUE,
  PRODUCT_DETAILS_PAGE_LABEL.EDIT_IN_3D_LABEL,
  PRODUCT_DETAILS_PAGE_LABEL.COPY_EDITS_VALUE,
  PRODUCT_DETAILS_PAGE_LABEL.PASTE_APPLY_VALUE,
];

const filteredSeparateActionMenu = (isLoggedIn = false, isPublicPage = false) => {
  if ((isLoggedIn && isPublicPage) || !isPublicPage) return [...SeparateActionMenu];
  return SeparateActionMenu.filter(({ value }) => !DoNotShowMenusInPublicPage.includes(value));
};

const handleOpenCurator = (data, dispatch) => {
  if (!checkIfMemberHaveEditorAccess()) return;
  if (data?.render_image_details) {
    Mixpanel.track(true, MxEvent.EDIT_IN_3D_IMAGE, {
      image_id: data?.render_image_details?.main_render,
      image_name: data?.render_image_details?.angle_name,
      image_angle_name: data?.render_image_details?.angle_name,
    });

    dispatch(
      setTemporaryPreventBackupPopup({
        type: 'room',
        id: data?.render_image_details?.main_render,
      })
    );
    const url = getCuratorRenderPreviewPath(
      data?.render_image_details?.main_render,
      data?.render_image_details?.angle_name
    );
    window.open(`${url}&isFromProductPage=true`, '_blank');
  }
};

let breadcrumbsList = [
  {
    label: 'Products',
    link: ADMIN_MY_PRODUCTS_3DMODAL_V2,
  },
  {
    label: 'My Models',
    link: ADMIN_MY_PRODUCTS_3DMODAL_V2,
  },
];

let cloneProductDetails = null,
  initialPageLoad = true;
const intialAddbuttonState = JSON.stringify({
  category: false,
  subCategory: false,
  tags: false,
});

export const getImageSrc = (image, pass, editedImages = {}) => {
  if (!image) return image;
  if (!image?.render_image_details)
    // || image?.is_edited_image)
    return image.image_file || image.gif_file;
  const currentPass = pass?.[image?.id]?.current;
  if (currentPass === PASS.ORIGINAL) return getRenderOriginalFile(image);
  else if (currentPass === PASS.STANDARD) return image.render_image_details.file;
  // Falls back to the original while the preview is still being generated.
  else if (currentPass === PASS.POST_EDIT)
    return editedImages?.[image?.id] || getRenderOriginalFile(image);
  else if (currentPass === PASS.FILMIC)
    return image.render_image_details.filmic_file;
  else if (currentPass === PASS.COLOR)
    return image.render_image_details.color_pass_file;
};

/**
 * Saves `image` the way the preview shows it - the render's own file for the
 * pass on screen, or the Post Edit image when that pass is active. The card's
 * `image_file` is a re-encoded copy that has lost the render's DPI, so it is
 * only used for images that aren't renders.
 *
 * Goes through the shared download controller so the transfer shows up in the
 * Downloads snackbar, the same as every other download in the app.
 *
 * `fromPassSelector` marks a call from the lightbox, the only place a pass is
 * picked by hand. There the selection is honoured and named, so the passes of
 * one image can be told apart. A card has no selector, and the pass map is
 * reset to the render's own img_type every time the lightbox closes - so
 * reading it from a card hands back the unedited render for an image that has
 * edits. A card goes by the image itself instead.
 */
export const downloadImage = async ({
  image,
  pass,
  editedImages,
  ensureEditedImage,
  fromPassSelector = false,
}) => {
  if (!image) return;

  const isEdited = !!Object.keys(image?.render_image_details?.edit_config || {}).length;
  const currentPass = fromPassSelector ? pass?.[image?.id]?.current : null;

  // An edited image's own file already holds the edited picture - written there
  // when the edits were saved, and the same file the card thumbnail comes from -
  // so a card saves what it is showing. Anything else takes the render as
  // produced, since the image_file copy of an unedited render has lost its DPI.
  // getImageSrc comes back empty when the record has no file for the pass, so
  // the fallbacks keep Download from quietly doing nothing.
  const fileUrl =
    (!fromPassSelector && isEdited && image?.image_file) ||
    getImageSrc(image, pass, editedImages) ||
    getRenderOriginalFile(image) ||
    image?.image_file ||
    image?.gif_file;
  if (!fileUrl) return;

  // A blob: URL carries no extension, so the edited image takes the original's
  // - which is also the format it was encoded back into.
  const extension = getUrlExtension(getRenderOriginalFile(image)) || getUrlExtension(fileUrl);
  // Suffixed the way Render Details names its downloads, so the passes of one
  // image are telling apart from each other in the download folder. Original
  // keeps the plain name, being the render as produced.
  const fileNameFor = (variation) =>
    [[image?.name, variation].filter(Boolean).join('_'), extension].filter(Boolean).join('.') ||
    undefined;

  // Post Edit is rendered on demand - loading the render, the canvas pass and
  // the DPI read take seconds, and the blob they produce then saves instantly.
  // downloadPrepared opens the snackbar row for the whole job, where `download`
  // would only cover the transfer at the very end of it.
  if (currentPass === PASS.POST_EDIT) {
    await downloadPrepared({
      fileName: fileNameFor('post_edit'),
      prepare: () => ensureEditedImage(image),
    });
    return;
  }

  // The lightbox names the pass it saved. A card has no pass to name, so an
  // edited image is only marked as edited.
  const cardVariation = isEdited ? 'post_edit' : null;

  await download({
    fileUrl,
    // Without a name the controller falls back to the one on the URL.
    fileName: fileNameFor(
      fromPassSelector ? IMAGE_VARIATION_TYPE[currentPass]?.toLowerCase() : cardVariation
    ),
  });
};

export const getImageTypeFooterComponent = ({
  pass,
  setPass,
  images,
  photoIndex,
  style = {},
  canViewEditPasses = false,
}) => {
  const image = images?.[photoIndex];
  const imageId = image?.id;
  if (!imageId || !image?.render_image_details) return [];

  let passOptions = [];

  // Original/Post Edit for an image that carries saved edits. Seeing the two is viewing, not
  // editing, so it never depends on PERMISSION.IMAGE_EDITOR - a signed-out visitor on the public
  // page, and a signed-in viewer who can't open the editor, both land on the edited picture.
  // `canViewEditPasses` only says whether the caller can actually render the Post Edit pass;
  // a surface that doesn't wire up editedImages leaves it off rather than label the original.
  if (canViewEditPasses && image?.render_image_details?.edit_config && Object.keys(image?.render_image_details?.edit_config).length) {
    passOptions = [
      {
        value: PASS.ORIGINAL,
        name: 'Original',
      },
      {
        value: PASS.POST_EDIT,
        name: 'Post Edit',
      },
    ];
  } else {
    // Default options for non-editors or images without edit_config
    passOptions = [
      {
        value: PASS.STANDARD,
        name: 'Standard',
      },
      {
        value: PASS.FILMIC,
        name: 'Filmic',
      },
      {
        value: PASS.COLOR,
        name: 'Color',
      },
    ];
  }

  return (
    <div
      className={`${styles.previewUI} image-type-btn`}
      style={{ height: 0, zIndex: 1001, ...style }}>
      <div className={cx(styles.passBtnContainer, ' d-flex justify-content-end')}>
        <ButtonGroup>
          {passOptions?.map((p, i) => (
            <ToggleButton
              key={i}
              id={`radio-${i}-${imageId}`}
              type="radio"
              variant="light"
              name="pass"
              value={p.value}
              checked={pass?.[imageId]?.current === p.value}
              onChange={(e) => {
                setPass({
                  ...pass,
                  [image?.id]: { ...pass?.[imageId], current: e.currentTarget.value },
                });
              }}
              className={cx(
                pass?.[imageId]?.current === p.value ? 'pass-btn active' : 'pass-btn',
                !images?.[photoIndex]?.render_image_details?.color_pass_file &&
                  p.value === PASS.COLOR &&
                  styles.hidden
              )}>
              {p.name} {pass?.[imageId]?.default === p.value ? ' *' : ''}
            </ToggleButton>
          ))}
        </ButtonGroup>
      </div>
    </div>
  );
};

const defaultProductPrice = '100';
const defaultProductDescription =
  'Immerse yourself in a world where precision meets craftsmanship, showcasing the perfect blend of aesthetics, functionality and discover unparalleled quality with our exceptional product.';

const getDefaultSKU = ({ id = '', name = '' }) => {
  if (!id.toString() || !name) return '';

  const _id = id.toString().slice(0, 3);
  let idStr = '';
  let difference = Math.abs(_id.length - 3);

  if (difference !== 0) {
    for (let i = 0; i < difference; i++) {
      idStr += 0;
    }
  }
  idStr += _id;
  return `${name.slice(0, 2).toUpperCase()}-${idStr}`;
};

const defaultDimension = '__L x __W x __H Inches';

const getDimension = (d = '') => {
  if (!d) return '';
  let dimension = d;
  if (dimension.includes('inches')) {
    return dimension;
  }
  return `${dimension} Inches`;
};

export default function ProductDetails(props) {
  const routeParams = useParams();
  const productId = props.publicProductId || routeParams.id;
  return <ProductDetailsInner key={productId} {...props} />;
}

function ProductDetailsInner({ publicProductId = null, publicProductOrgId = null }) {
  const routeParams = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser, isEditor, isGuestUser } = useUserContext();
  // parseInt on a route id that is not a number gives NaN, which then reached
  // the list APIs verbatim as `product=NaN`. undefined instead: it is stripped
  // from a query string rather than serialised, and every `!productId` guard
  // already treats it as no id at all.
  const routeProductId = Number.parseInt(routeParams.id, 10);
  let productId =
    publicProductId || (Number.isFinite(routeProductId) ? routeProductId : undefined);
  const isPublicPage = publicProductId;
  // Nothing can be loaded for an id that isn't one, so rather than leaving an
  // empty page behind requests that could never succeed, say so and go back to
  // the listing - which is what a failed detail fetch already does.
  useEffect(() => {
    if (publicProductId || productId) return;
    warningToast('This product link is not valid. Taking you back to My Models.');
    navigate(ADMIN_MY_PRODUCTS_3DMODAL_V2);
  }, [productId, publicProductId]);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('activeTab') || PRODUCT_DETAILS_TAB.SHOWCASE;
  const productOrg = publicProductOrgId; //searchParams.get('product_org');
  const [editFlag, setEditFlag] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imageListForOpenModalType, setImageListForOpenModalType] = useState([]); // keeps the list of Silos if opened from Silos menu, otherwise Lifestyle imagery
  const [initialTab, setInitialTab] = useState(false);
  const [type, setType] = useState(null);
  const [productInfo, setProductInfo] = useState(null);
  const [data, setData] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allDataLoading, setDataLoading] = useState({
    viewer360: true,
    productDetails: true,
  });
  const [error, setError] = useState({});
  const [refresh, setRefresh] = useState(null);
  const [addButtonActive, setAddButtonActive] = useState({
    ...JSON.parse(intialAddbuttonState),
  });
  const [publicRealProductId, setPublicRealProductId] = useState(null);
  const [productUnicodeId, setProductUnicodeId] = useState(null);
  const [orgProductUniqueCodeId, setOrgProductUniqueCodeId] = useState(null);
  const [showCreateVideoPopup, setShowCreateVideoPopup] = useState(false);
  const [AIVideoProcessingStatus, setAIVideoProcessingStatus] = useState(false);
  const [isPackProduct, setIsPackProduct] = useState(false);
  const [isProductPackExpiry, setIsProductPackExpiry] = useState(false);

  usePageTitle(data?.name);

  const {
    data: productDetails,
    loading: productDetailsLoading,
    refetch: productDetailsRefetch,
    update: updateProductDetails,
  } = useApi({
    api: isPublicPage ? apiGetPropPublicInfo : apiGetWebExperienceProductDetails,
    id: productId,
  });

  const { favouriteLoading, onFavouriteToggle, onShare, addToCollection } = useProductActions({
    item: data,
    modelType: MODEL_TYPES.PRODUCT,
  });

  useEffect(() => {
    let timerId;
    // The tracking works only on public page
    if (isPublicPage && shouldTrackPageViewed() && data?.id) {
      const productUUID = routeParams.id;

      timerId = setTimeout(() => {
        // Check if one hour has passed since the last page view for the given product.
        const isOneHourPassed = getAndSetCookieData({
          cookieName: `ppv_${productUUID}`, // ppv - product page viewed
        });

        // If one hour has not passed since the last view, send the page view data.
        if (!isOneHourPassed) {
          sendProductPageViewedData({
            productUUID: productUUID,
          });
        }
      }, 5000);
    }
    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [isPublicPage, data]);

  useEffect(async () => {
    if (!productId || isPublicPage) return;
    const response = await apiGetPdpProducts({ id: productId });
    if (response?.results?.length) {
      dispatch(setPdpProductDetails(response.results[0]));
      dispatch(setPdpProductCountInfo(response?.results[0]?.deliverables || {}));
    }
  }, []);

  const checkIsPackProduct = async () => {
    const result = await apiCheckIsPackProductViaId(isPublicPage ? data?.id : productId);
    if (
      result &&
      result?.status &&
      data?.request_details?.id &&
      data?.request_details?.status === REQUEST_STATUSES.LIVE_ON_APP.value
    ) {
      const request = await apiGetRequest(data?.request_details?.id);
      if (request) {
        setIsProductPackExpiry(
          request?.model_request?.packinfo_details?.every((a) => a?.is_expiry)
        );
      }
      setIsPackProduct(result?.data?.is_pack);
      window.$isPackProduct = result?.data?.is_pack;
    } else {
      setIsPackProduct(false);
      window.$isPackProduct = false;
    }
  };

  useEffect(() => {
    return () => {
      if (window.$restrictFilter) {
        window.$previousURL && navigate(window.$previousURL);
        setTimeout(() => {
          handleScrollPage();
          handleClearWindowState();
        }, 1500);
      }
    };
  }, []);

  useEffect(() => {
    let root = document.getElementsByTagName('html')?.[0]; // '0' to assign the first (and only `HTML` tag)
    root.setAttribute('class', 'overflow-x-hidden');
    return () => {
      root.removeAttribute('class', 'overflow-x-hidden');
    };
  }, []);

  useEffect(() => {
    if (currentUser && productInfo) {
      navigate(ADMIN_MY_PRODUCTS_3DMODAL_V2);
    }
    return () => {
      dispatch(sharePopupActions.clear());
      dispatch(addToCollectionActions.clear());
    };
  }, [currentUser?.id]);

  useEffect(() => {
    if (!currentUser || isPublicPage) return;
    if (data && +data?.owner_organization === +currentUser?.organization) {
      checkIsPackProduct();
    } else {
      setIsPackProduct(false);
      window.$isPackProduct = false;
    }
  }, [productId, data, currentUser]);

  useEffect(async () => {
    if (productId && productUnicodeId) {
      if (currentUser) dispatch(setClientSubscriptionPlans());
      getProduct360Images();
    }
  }, [productId, productUnicodeId]);

  useEffect(async () => {
    document.getElementById('product-container')?.focus();
  }, []);

  useEffect(async () => {
    if (!favouriteLoading) {
      fetchData();
      initialPageLoad = false;
    }
  }, [favouriteLoading]);

  useEffect(() => {
    Object.keys(error).length && setError({});
    editFlag && setEditFlag(false);
    setAddButtonActive({ ...JSON.parse(intialAddbuttonState) });
    if (cloneProductDetails) cloneProductDetails = null;
  }, [activeTab]);

  useEffect(async () => {
    if (productDetails && !productDetailsLoading) {
      if (productDetails?.status && !Object.keys(productDetails?.data)?.length) {
        navigate(ADMIN_MY_PRODUCTS_3DMODAL_V2);
      }

      let _productDetails = { ...productDetails } || {};

      setPublicRealProductId(_productDetails?.id);

      if (currentUser) {
        setLoading(true);
        const response = await apiGetPublicUUID(`?product=${_productDetails?.id}`);
        if (response?.results?.length) {
          const pdpDetails = response?.results[0]?.pdp_product_details || null;
          setOrgProductUniqueCodeId(response.results[0]?.unique_code);
          dispatch(setPdpProductDetails(pdpDetails));
          dispatch(setPdpProductCountInfo(pdpDetails?.deliverables || {}));
          setLoading(false);
        } else {
          const formData = new FormData();
          formData.append('product', _productDetails?.id);
          const response = await apiCreatePublicUUID(formData);
          if (response?.status) {
            const pdpDetails = response?.data?.pdp_product_details || null;
            dispatch(setPdpProductDetails(pdpDetails));
            dispatch(setPdpProductCountInfo(pdpDetails?.deliverables || {}));
            setOrgProductUniqueCodeId(response?.data?.unique_code);
            setLoading(false);
          }
        }

        if (isPublicPage) {
          const res = await apiGetWebExperienceProductDetails({ id: _productDetails?.id });
          if (res?.id) {
            _productDetails = {
              ..._productDetails,
              ai_video_status: res?.ai_video_status,
              configurator_status: res?.configurator_status,
              product_viewer_status: res?.product_viewer_status,
              video_status: res?.video_status,
            };
          }
        }
      } else {
        setOrgProductUniqueCodeId(routeParams.id);
      }

      setProductUnicodeId(_productDetails?.unicode);
      setProductInfo(_productDetails);
    }
  }, [productDetails, productDetailsLoading]);

  const fetchData = async (id) => {
    const productToFetch = id || productId;
    // Without an id this went out as `get-products/detail/undefined/`. The
    // invalid-link warning above has already handled it, so just stop - but
    // clear the flag, or the page sits on its loader for good.
    if (!productToFetch) {
      setDataLoading((prev) => ({ ...prev, productDetails: false }));
      return;
    }
    const api = isPublicPage ? apiGetPropPublicInfo : apiGetPropOptimized || apiGetProp;
    const result = await api(productToFetch);
    setDataLoading((prev) => ({ ...prev, productDetails: false }));
    if (result) {
      setData(result);
    } else {
      navigate(ADMIN_MY_PRODUCTS_3DMODAL_V2);
    }
  };

  const getProduct360Images = async (value) => {
    const api = isPublicPage ? apiGetProduct360UploadImagesPublic : apiGetProduct360UploadImages;
    const res = await api(productId || value);

    // const res = await getSubscriptionLinkedProductData({
    //   type: LINKED_PRODUCT_DATA.PRODUCT_VIEWER,
    //   isPublicPage: isPublicPage && !currentUser,
    //   params: {
    //     product_uuid: productUnicodeId,
    //     product_org: productOrg || currentUser?.organization
    //   }
    // });
    if (res && res?.results?.length > 0) {
      const imgList = res?.results;

      let loadedImages = [];
      await Promise.allSettled(
        imgList.map(async (image) => {
          const res = await loadImageAsync(image.image_file);
          if (res) {
            loadedImages.push(image);
          }
        })
      );

      setProductImages(SortArrayBySeq(loadedImages, 'sequence_number'));
    } else {
      setProductImages([]);
    }
    setDataLoading((prev) => ({ ...prev, viewer360: false }));
  };

  const handleToggleFavourite = () => {
    onFavouriteToggle(data)(data);
  };

  const handleAddColletion = () => {
    addToCollection(data);
  };

  const handleShareProduct = () => {
    onShare(data);
    if (+window.$shareItem?.product !== +data?.id) {
      window.$shareItem = null;
      window.$shareFlag = false;
    }
  };

  const handleShowInput = (key, value) => {
    setAddButtonActive({
      ...addButtonActive,
      [key]: value,
    });
  };

  const handleError = () => {
    let errorList = {};
    if (!productInfo?.name) {
      errorList.name = 'Name is required!';
    }
    if (productInfo?.price) {
      const re = /^\d*\.?\d*$/;
      if (!re.test(+productInfo?.price)) {
        errorList.price = 'Please add valid price!';
      }
    }
    // if (productInfo?.filteroptions?.length) {
    //   const cat = productInfo?.filteroptions?.some(
    //     ({ filter_label }) => +filter_label === PRODUCT_CATEGORY_VALUE.CATEGORY
    //   );
    //   const subCat = productInfo?.filteroptions?.some(
    //     ({ filter_label }) => +filter_label === PRODUCT_CATEGORY_VALUE.SUB_CATEGORY
    //   );
    //   if (!cat) {
    //     errorList.category = 'Category is required!';
    //   }
    //   if (!subCat) {
    //     errorList.subCategory = 'Subcategory is required!';
    //   }
    // } else {
    //   errorList.category = 'Category is required!';
    //   errorList.subCategory = 'Subcategory is required!';
    // }

    // if (!productInfo?.tags?.length) {
    //   errorList.tags = 'Tags are required!';
    // }

    setError(errorList);
    return errorList;
  };

  const handleAddBreadcrumName = () => {
    let path = breadcrumbsList.slice();
    if (productDetails) {
      path.push({
        label: productDetails?.name,
      });
    }
    return path || [];
  };

  const breadcrumbsMenu = useMemo(() => {
    return <Breadcrumbs classNames="breadcrumbHeadeV2" list={handleAddBreadcrumName()} />;
  }, [productDetails]);

  const handleTabChange = (key) => {
    setSearchParams(`?activeTab=${key}`);
  };

  const toggleEdit = async ({ refresh } = {}) => {
    if (!editFlag) {
      cloneProductDetails = JSON.stringify(productInfo);
    }
    if (refresh) {
      await new Promise((resolve) => {
        setTimeout(async () => {
          await getProduct360Images();
          resolve();
        }, 2000);
      });
    }
    setError({});
    setAddButtonActive({ ...JSON.parse(intialAddbuttonState) });
    setEditFlag(!editFlag);
  };

  const handleOnChange = (key, event) => {
    if (Object.keys(error)?.length) {
      setError({});
    }
    let cloneProductInfo = { ...productInfo };
    cloneProductInfo[key] = event?.target?.value;
    setProductInfo(cloneProductInfo);
  };

  const handleCencelUpdateDetails = () => {
    setProductInfo(JSON.parse(cloneProductDetails));
    cloneProductDetails = null;
    toggleEdit();
  };

  const OnSave = async () => {
    const errors = handleError();
    if (Object.keys(errors)?.length) {
      return;
    }

    let updatedData = { filteroptions: [], tags: [] };
    Object.keys(productInfo).forEach((key) => {
      if (key.startsWith('filter')) {
        const options = productInfo[key];
        updatedData.filteroptions.push(...options.map((c) => c.id));
      } else if (key === 'tags') {
        const options = productInfo[key];
        updatedData.tags.push(...options.map((c) => c.value || c));
      } else {
        updatedData[key] = productInfo[key] || '';
      }
    });
    if (updatedData) {
      delete updatedData?.created_by;
      delete updatedData?.id;
      delete updatedData?.owner_organization;
    }
    if (updatedData?.sku_id?.trim() === 'null' || !updatedData?.sku_id) {
      updatedData.sku_id = '';
    }
    setLoading(true);
    const response = await apiUpdateWebExperienceProductDetails({
      id: productId,
      ...updatedData,
    });
    setLoading(false);
    if (response && response.status) {
      updateProductDetails?.(response?.data);
      cloneProductDetails = null;
      toggleEdit();
    }
  };

  const handleRemoveTag = (index) => {
    let cloneProductInfo = { ...productInfo };
    let tag = cloneProductInfo.tags?.slice();
    tag.splice(index, 1);
    cloneProductInfo['tags'] = tag;
    setProductInfo(cloneProductInfo);
  };

  const handleRemoveCategory = (value) => {
    let cloneProductInfo = { ...productInfo };
    let category = cloneProductInfo.filteroptions?.slice();
    const indexVal = category.findIndex(({ id }) => +id === +value?.value);
    if (~indexVal) {
      category.splice(indexVal, 1);
      cloneProductInfo['filteroptions'] = category;
    }
    setProductInfo(cloneProductInfo);
  };

  const productFilters = useFilterDropdownOptions({
    filterType: PRODUCT_FILTER_TYPE,
    fetchData: true,
  });

  const getFilterValue = (filterId) => {
    if (!productInfo?.filteroptions || !productFilters) return [];
    const ids = productInfo.filteroptions.map((o) => o.id);
    const filter = productFilters.find((filter) => filter.id === filterId);
    const value = filter.options.filter((category) => ids.includes(category.value));
    return value;
  };

  const handleAddTag = (e) => {
    if (e?.value) {
      if (Object.keys(error)?.length) {
        setError({});
      }
      let cloneProductInfo = { ...productInfo };
      let tag = cloneProductInfo.tags?.slice();
      tag.push(e?.value);
      cloneProductInfo['tags'] = tag;
      setProductInfo(cloneProductInfo);
    }
  };

  const handleAddCategoryAndSubCategory = (e, filterOption) => {
    if (e?.value) {
      if (Object.keys(error)?.length) {
        setError({});
      }
      let cloneProductInfo = { ...productInfo };
      let tag = cloneProductInfo.filteroptions?.slice();
      tag.push({ ...filterOption, id: e?.value, name: e?.lable });
      cloneProductInfo['filteroptions'] = tag;
      setProductInfo(cloneProductInfo);
    }
  };

  const generateAutomaticAIVideoPreview = async () => {
    if (!productInfo?.default_data?.default_auto_aivideo_room?.id) {
      errorToast('Default room Id is missing. Please try again later or connect with admin.');
      return;
    }

    if (!productInfo?.render_status) {
      setShowCreateVideoPopup(true);
    } else if (productInfo?.render_status?.status !== RENDER_STATUS.STATUS_DONE)
      infoToast('Please wait. Video previews are currently in processing.');
    else if (productInfo?.final_render_status) {
      if (
        !AIVideoProcessingStatus &&
        productInfo?.final_render_status?.status === RENDER_STATUS.STATUS_NOT_DONE
      )
        openInfoDialog({
          title:
            'Video is sent for rendering. Do you still want to cancel the process and edit it?',
          buttonText: 'Yes',
          cancelButtonText: 'No',
          onButtonClick: async () => {
            const formData = new FormData();
            formData.append('product', productId);

            await cancelAIVideoRender(formData);
          },
        });
      else infoToast('Please wait ! Final video is already processing.');
    } else open(ADMIN_MY_PRODUCTS_AIVIDEO_PREVIEW.replace(':id', productId));

    //TODO: Handle condition for different statuses
    // infoToast("Video is in progress")
  };

  const handleRefresh = async (value) => {
    // https://app.clickup.com/t/3326989/DEV-42695
    // Waiting for 1.5 second because thumbnail generation takes some time,
    // which occasionally causes issues.
    await wait(1500);
    setRefresh(value);
  };

  const createProductVideo = async (_roomId) => {
    const formData = new FormData();
    formData.append('products', productId);
    formData.append('auto_product', productId);
    formData.append('rooms_list', _roomId);
    formData.append('is_auto_aivideo_preview', true);
    formData.append('is_auto_aivideo_render', false);
    const response = await createAutomaticAIVideoPreview(formData);

    if (response?.status) {
      successToast('Preview videos has been successfully sent for rendering.');
      setProductInfo({ ...productInfo, render_status: true });
      setShowCreateVideoPopup(false);
    }
  };

  const isLoading = Object.keys(allDataLoading).some((key) => allDataLoading[key]);
  const loaderValue = isLoading; // || productDetailsLoading; // loading

  const topMenuList = [
    {
      label: 'Favourite',
      icon: !data?.is_favourite ? <FavoriteIcon /> : <FavoriteRedIcon />,
      onClick: handleToggleFavourite,
      show: true,
    },
    {
      label: 'Share',
      icon: <ShareProductIcon />,
      onClick: handleShareProduct,
      show: true,
    },
    {
      label: 'Collection',
      icon: <AddPlusIcon />,
      onClick: handleAddColletion,
      show: true,
    },
    {
      label: 'Edit',
      icon: <EditPensilIcon />,
      onClick: toggleEdit,
      show: isEditor ? true : false,
    },
    {
      label: 'AI Video',
      icon: <AIVideoIcon />,
      onClick: generateAutomaticAIVideoPreview,
      // show: productInfo?.final_render_status?.status !== RENDER_STATUS.STATUS_DONE ? true : false,
      // For now keeping it false as per discussion
      show: false
    },
  ];

  const handleSelect = (method) => {
    method?.onClick && method?.onClick();
  };

  return (
    <>
      <div className="product-details" id="product-container">
        {loaderValue && (
          <Loader
            loading={true}
            position="fixed"
            style={{ backgroundColor: '#fff' }}
            size={30}
            thickness={3}
          />
        )}
        {showModal && (
          <UploadRenderModal
            startOpen={showModal}
            {...{
              imageListForOpenModalType,
              setImageListForOpenModalType,
              setShowModal,
              type,
              productInfo,
              productId,
              initialTab,
              setInitialTab,
            }}
            handleRefresh={handleRefresh}
          />
        )}

        {!isPublicPage ? (
          <div
            className={`justify-content-between align-items-center mb-1 ${
              editFlag ? 'd-flex top-btn-actions' : 'd-xl-flex d-md-block d-flex'
            }`}>
            {breadcrumbsMenu}
            {isGuestUser() ? null : (
              <div className="d-flex flex-wrap gap-2 px-md-4 px-2">
                {editFlag ? (
                  <div className="action-button">
                    <Button
                      color="light"
                      onClick={() => {
                        handleCencelUpdateDetails();
                      }}
                      size="xlg"
                      className="so-icon-button"
                      iconBefore={<CancelIcon />}>
                      {' '}
                      Cancel
                    </Button>
                    <Button
                      color="dark"
                      onClick={OnSave}
                      size="xlg"
                      className="so-icon-button"
                      iconBefore={<CheckMarkIcon />}>
                      Save
                    </Button>
                  </div>
                ) : (
                  <>
                    <div className="d-flex d-md-none align-items-center gap-2">
                      <VariantDropdown productDetails={data} />
                      <MenuDropdown
                        defaultPrevent
                        menu={topMenuList?.filter(({ show }) => show)}
                        handleSelect={handleSelect}
                      />
                    </div>
                    <div className="d-md-flex d-none align-items-center gap-2">
                      <VariantDropdown productDetails={data} />
                      <Button
                        color="light"
                        size="xlg"
                        className="so-icon-button"
                        onClick={handleToggleFavourite}
                        loading={favouriteLoading}
                        iconBefore={!data?.is_favourite ? <FavoriteIcon /> : <FavoriteRedIcon />}>
                        Favourite
                      </Button>
                      <Button
                        color="light"
                        size="xlg"
                        className="so-icon-button"
                        onClick={handleShareProduct}
                        iconBefore={<ShareProductIcon />}>
                        Share
                      </Button>
                      <Button
                        color="light"
                        size="xlg"
                        className="so-icon-button"
                        onClick={handleAddColletion}
                        iconBefore={<AddPlusIcon />}>
                        Collection
                      </Button>
                      {isEditor && (
                        <>
                          <Button
                            color="light"
                            size="xlg"
                            className="so-icon-button"
                            iconBefore={<EditPensilIcon />}
                            onClick={toggleEdit}>
                            Edit
                          </Button>

                          {/* {productInfo?.final_render_status?.status !==
                          RENDER_STATUS.STATUS_DONE ? (
                            <Button
                              color="light"
                              size="xlg"
                              className="so-icon-button"
                              iconBefore={<AIVideoIcon />}
                              onClick={generateAutomaticAIVideoPreview}>
                              AI Video
                            </Button>
                          ) : null} */}
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        ) : null}

        {/* Tab code of showcase and Files */}
        <div
          className={`setting-tabs ${
            !checkIfEmailIsVerifiedOrNot(false) && !isPublicPage ? 'bottom-space' : ''
          }`}>
          <Tabs
            className="mySettings-top-tabs d-none"
            mountOnEnter
            activeKey={activeTab}
            onSelect={handleTabChange}>
            <Tab eventKey={PRODUCT_DETAILS_TAB.SHOWCASE} title={PRODUCT_DETAILS_TAB.SHOWCASE}>
              <ShowCaseDetails
                {...{
                  editFlag,
                  productInfo,
                  handleOnChange,
                  handleRemoveTag,
                  handleRemoveCategory,
                  productFilters,
                  getFilterValue,
                  error,
                  handleShowInput,
                  addButtonActive,
                  data,
                  handleAddTag,
                  handleAddCategoryAndSubCategory,
                  toggleEdit,
                  productImages,
                  loaderValue,
                  productId,
                  isPublicPage,
                  publicRealProductId,
                  productUnicodeId,
                  orgProductUniqueCodeId,
                  refetchDetails: productDetailsRefetch,
                  loading,
                  isPackProduct: isPackProduct && !isProductPackExpiry, // check if product is pack and not expired
                }}
              />
              <SilosListShowCase
                title="Silos"
                imageType={ROOM_TYPE.SILO}
                actionMenu={imagesActionMenu}
                {...{
                  setInitialTab,
                  setType,
                  setShowModal,
                  setImageListForOpenModalType,
                  productId,
                  refresh,
                  setRefresh,
                  isPublicPage,
                  filteredSeparateActionMenu,
                  handleOpenCurator,
                  downloadImage,
                  getImageTypeFooterComponent,
                }}
              />
              <ImageryShowCase
                title="Lifestyle imagery"
                imageType={ROOM_TYPE.LIFESTYLE}
                actionMenu={imagesActionMenu.filter(
                  (a) => a.value !== PRODUCT_DETAILS_PAGE_LABEL.RE_ORDER_VALUE
                )}
                {...{
                  setInitialTab,
                  setType,
                  setShowModal,
                  setImageListForOpenModalType,
                  productId,
                  refresh,
                  setRefresh,
                  isPublicPage,
                  filteredSeparateActionMenu,
                  handleOpenCurator,
                  downloadImage,
                  getImageTypeFooterComponent,
                }}
              />
              {/* <ImageryShowCase
                title="Vignette imagery"
                imageType={ROOM_TYPE.VIGNETTE}
                headerClassName="mt-0"
                actionMenu={imagesActionMenu.filter(
                  (a) => a.value !== PRODUCT_DETAILS_PAGE_LABEL.RE_ORDER_VALUE
                )}
                {...{
                  setInitialTab,
                  setType,
                  setShowModal,
                  productId,
                  refresh,
                  setRefresh,
                  isPublicPage,
                  filteredSeparateActionMenu,
                  handleOpenCurator,
                  getImageSrc,
                  getImageTypeFooterComponent,
                }}
              /> */}
              <VideoTabShowcase
                {...{
                  productId: publicRealProductId,
                  productInfo,
                  isPublicPage,
                  productUnicodeId,
                  orgProductUniqueCodeId,
                  productOrg,
                  refetchDetails: productDetailsRefetch,
                  setAIVideoProcessingStatus,
                  isPackProduct,
                }}
              />
              <ConfiguratorShowCase
                {...{
                  productId: publicRealProductId,
                  productInfo,
                  isPublicPage,
                  productUnicodeId,
                  orgProductUniqueCodeId,
                  productOrg,
                  refetchDetails: productDetailsRefetch,
                  isPackProduct: isPackProduct && !isProductPackExpiry, // check if product is pack and not expired
                }}
              />
            </Tab>
          </Tabs>
          <AddToCollectionPopup />
        </div>
        {showCreateVideoPopup ? (
          <CreateVideoPopUp
            show={showCreateVideoPopup}
            setShow={setShowCreateVideoPopup}
            submitRenderJob={createProductVideo}
            defaultRoom={productInfo?.default_data?.default_auto_aivideo_room}
          />
        ) : null}
      </div>
    </>
  );
}

export const ShowCaseDetails = memo(
  ({
    editFlag,
    productInfo,
    handleOnChange,
    // handleRemoveTag,
    // handleRemoveCategory,
    // productFilters,
    // getFilterValue,
    error,
    data,
    loaderValue,
    // handleShowInput,
    // addButtonActive,
    // handleAddTag,
    // handleAddCategoryAndSubCategory,
    toggleEdit,
    productImages,
    productId,
    isPublicPage,
    publicRealProductId,
    productUnicodeId,
    orgProductUniqueCodeId,
    loading,
    refetchDetails,
    isPackProduct,
  }) => {
    const {
      isOldSubscriptionUser,
      isPremiumUser,
      isEditor,
      currentUser,
      isGuestUser,
      isGuestLogin,
    } = useUserContext();
    const { isFreemiumUser, isFreemiumOrSelfServeUser, hideNewPlans } =
      useCurrentOrganizationInfo();
    const { hasPermission } = useStaticPermissions();
    const [imageLoaded, setImageLoaded] = useState(false);
    // const [tagsList, setTagsList] = useState([]);
    // const [search, setSearch] = useState('');
    // const [page, setPage] = useState(1);
    const [viewerFullScreen, setViewerFullScreen] = useState(false);

    const [state, copy] = useCopyToClipboard();

    const threeSixtyViewerRef = useRef();

    const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();

    const activePlan = useSelector(selectUserActivePlanDetails) || isOldSubscriptionUser();
    const available3DViewerCount = useSelector(selectAvailable3DViewerAR);
    // const highestPlanOrder = useSelector(selectHighestPlanOrderId);
    // const activePlanOrder = useSelector(selectUserActivePlanSubscriptionOrderId);
    const { results: addonsList } = useSelector(selectAddonsList);

    const getUserPlans = useSelector(selectUserPlanList);
    const isOldPremiumUser = isPremiumUser() && getUserPlans?.length === 0;

    // const showUpgradeButton = highestPlanOrder > activePlanOrder;

    const [actionMenu, setActionMenu] = useState([]);
    const pdpProductCountInfo = useSelector(selectPdpProductCountInfo);
    const pdpArViewerCount = pdpProductCountInfo?.ar_viewer || 0;

    useEffect(() => {
      setActionMenu([
        {
          id: 1,
          title: 'Disabled',
          icon: null,
          onClick: handleEnabledDisabled,
          type: 'toggle',
          initialValue: false,
        },
        { id: 2, title: 'Copy Link', icon: null, onClick: handleCopy, disabled: true },
        { id: 3, title: 'Embed on website', icon: null, onClick: handleEmbedding, disabled: true },
      ]);
    }, [
      productUnicodeId,
      orgProductUniqueCodeId,
      productInfo?.product_viewer_status,
      pdpArViewerCount,
      isPackProduct,
    ]);

    useEffect(() => {
      setActionMenu((prev) => [
        ...prev
          .map((a) => {
            if (a.id === 1 && !isPackProduct) {
              return {
                ...a,
                title:
                  productInfo?.product_viewer_status || pdpArViewerCount ? 'Enabled' : 'Disabled',
                initialValue: productInfo?.product_viewer_status || pdpArViewerCount,
                disabled: pdpArViewerCount ? true : false,
              };
            }
            if (a.id === 1 && isPackProduct) return null;
            return {
              ...a,
              disabled: isPackProduct
                ? false
                : pdpArViewerCount || productInfo?.product_viewer_status
                  ? false
                  : true,
            };
          })
          .filter(Boolean),
      ]);
    }, [
      productUnicodeId,
      orgProductUniqueCodeId,
      productInfo?.product_viewer_status,
      pdpArViewerCount,
      isPackProduct,
    ]);

    // useEffect(() => {
    //   fetchGlobalTags();
    // }, [page, search]);

    // const fetchGlobalTags = async () => {
    //   const response = await apiGetGlobalTags({ search, page });
    //   setTagsList(page > 1 ? [...tagsList, ...response?.results] : response?.results || []);
    // };

    // const handleSearchOrg = debounce((e) => {
    //   setSearch(e);
    //   setPage(1);
    // }, 300);

    // const handleNext = () => {
    //   setPage(+page + 1);
    // };

    // const handleLoadOptions = (value) => {
    //   let filterRecord = [];
    //   value &&
    //     value?.length &&
    //     value?.map((list) => {
    //       if (!productInfo?.tags?.includes(list?.name)) {
    //         return filterRecord.push({ label: list?.name, value: list?.name, all: list });
    //       }
    //     });
    //   return filterRecord;
    // };

    // const handleLoadCategoryOption = (value) => {
    //   let filterRecord = [];
    //   value &&
    //     value?.length &&
    //     value?.map((list) => {
    //       if (!productInfo?.filteroptions?.some(({ id }) => +id === +list?.value)) {
    //         return filterRecord.push(list);
    //       }
    //     });
    //   return filterRecord;
    // };

    // const handleLoadTagsAndCategory = () => {
    //   let filterDataList = [];
    //   productInfo &&
    //     productFilters?.map((filter) => {
    //       const { fieldsConfig } = getCategoryFields(filter, getFilterValue(filter?.id));
    //       filterDataList = [...filterDataList, ...fieldsConfig[0]?.value];
    //     });
    //   filterDataList = [...filterDataList, ...productInfo?.tags];
    //   return filterDataList;
    // };

    async function doEnableDisable(toggleValue) {
      const formData = new FormData();
      formData.append('type', LINKED_PRODUCT_DATA.PRODUCT_VIEWER);
      formData.append('is_link', toggleValue);
      formData.append('product_id', publicRealProductId || productId);
      const res = await linkSubscriptionProductData(formData);
      if (res?.status) {
        successToast(res?.message);
      } else {
        toggleValue = false;
      }
      dispatcher(setClientSubscriptionPlans());
      refetchDetails?.();

      const updatedMenu = actionMenu.map((a) => {
        if (a.id === 1) {
          return {
            ...a,
            title: toggleValue ? 'Enabled' : 'Disabled',
            initialValue: toggleValue,
          };
        }
        return {
          ...a,
          disabled: !toggleValue,
        };
      });
      setActionMenu(updatedMenu);
    }

    function openModelWhileDisabling(toggleValue) {
      openInfoDialog({
        title: '360° Viewer',
        description:
          'Disabling 360° viewer will also disable AR viewer. This will disable the public link or embedded link you used. Are you sure you want to continue?',
        buttonText: 'Yes',
        onButtonClick: () => doEnableDisable(toggleValue),
        cancelButtonText: 'No',
        dialogClassName: modalStyles.viewerModal,
        designV2: true,
        btnContainerClass: 'justify-content-end',
        designV2Props: {
          fillBtnClassName: modalStyles.viewerBtn,
          cancelBtnClassName: modalStyles.cancelBtn,
        },
      });
    }

    function handleEnabledDisabled(item) {
      item.e.stopPropagation();
      let toggleValue = item.value;
      if (toggleValue) doEnableDisable(toggleValue);
      else openModelWhileDisabling(toggleValue);
    }

    function handleCopy() {
      if (!orgProductUniqueCodeId) {
        errorToast('Unable to copy. Please try again later.');
        return;
      }
      const url =
        window.location.origin + PRODUCT_360_VIEWER_PUBLIC.replace(':id', orgProductUniqueCodeId);
      copy(url);
      successToast('Link Copied');
    }

    function handleEmbedding() {
      if (!orgProductUniqueCodeId) {
        errorToast('Unable to copy. Please try again later.');
        return;
      }
      const embedLink =
        window.location.origin + PRODUCT_360_VIEWER_PUBLIC.replace(':id', orgProductUniqueCodeId);
      const iframeCode = `<iframe style="border: none;" src="${embedLink}" title="${productInfo?.name}" width="100%" height="710px" allowfullscreen></iframe>`;
      copy(iframeCode);
      successToast('Embed Link Copied');
    }

    const buy3DviewerAndAr = async () => {
      await dispatcher(GetAllCartProductList());

      const addonsItem = addonsList?.find(
        ({ basemodeltype }) => basemodeltype === OFFER_PRICE_DATA['3D_Viewer'].baseModelType
      );
      let payload = {
        subscription_price: addonsItem?.id || OFFER_PRICE_DATA['3D_Viewer'].product_id,
        quantity: 1,
      };

      await removeAllItemsFromCart();

      const response = await AddAddonCart(payload, 'add');
      if (response?.status) {
        closeInfoDialog();

        let tab = SETTINGS_TAB.ADD_ONS;
        if (isFreemiumOrSelfServeUser) {
          tab = SETTINGS_TAB.PLANS;
        }

        windowOpen(
          `${ADMIN_SETTINGS}?activeTab=${tab}&checkout=true&is_one_time=false&referrer=${window.location.href}`,
          '_blank'
        );
      }
    };

    const handleShowPopup = () => {
      if (isFreemiumUser) {
        openFormInCaseOfNewOrgAndFreemiumUser();
        return;
      } else {
        navigateToUpgradePlan({ browsePlan: true, newTab: true, referrer: window.location.href });
      }
    };

    const handleShareForUse = () => {
      let title = 'Add item';
      let description = '';
      let buttonText = '';
      let buttonText2 = '';
      let onButtonClick = null;
      let onButtonClick2 = null;
      if (isPdpProduct()) {
        if (!pdpArViewerCount) {
          openFormInCaseOfNewOrgAndFreemiumUser();
          return;
        }
        return;
      }
      if (hideNewPlans) {
        // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
        openFormInCaseOfNewOrgAndFreemiumUser();
        return;
      }
      if (isOldPremiumUser && available3DViewerCount === 0) {
        title = 'Buy add on';
        buttonText = 'Buy';
        description = 'This item will be added on top of your existing subscription (if any).';
        onButtonClick = buy3DviewerAndAr;
      } else if (!activePlan && available3DViewerCount === 0) {
        buttonText = 'View plans';
        description =
          'You currently do not have an active subscription. Please purchase a subscription plan or buy this item separately.';
        onButtonClick = () => handleShowPopup();
        buttonText2 = 'Buy item';
        onButtonClick2 = buy3DviewerAndAr;
      } else if (available3DViewerCount === 0) {
        buttonText = 'Upgrade plan';
        description =
          'You do not have this item. Please upgrade your subscription plan or buy this item separately.';
        onButtonClick = () => handleShowPopup();
        buttonText2 = 'Buy item';
        onButtonClick2 = buy3DviewerAndAr;
      } else {
        return null;
      }
      openInfoDialog({
        title: title,
        description: description,
        buttonText: buttonText,
        onButtonClick: onButtonClick,
        buttonText2: buttonText2,
        onButtonClick2: onButtonClick2,
        btnContainerClass: 'align-items-center',
        addOrSeparator: false,
        designV2: true,
        closeable: false,
        designV2Props: {
          fillBtnClassName: modalStyles.fillBtn,
          okBtnClassName: modalStyles.btnLink,
        },
      });
    };

    const handleExitViewerFullScreen = () => {
      if (!document.fullscreenElement && !document.webkitFullscreenElement)
        setViewerFullScreen(false);
    };

    useEffect(() => {
      threeSixtyViewerRef?.current?.addEventListener(
        'fullscreenchange',
        handleExitViewerFullScreen
      );
      threeSixtyViewerRef?.current?.addEventListener(
        'webkitfullscreenchange',
        handleExitViewerFullScreen
      );

      return () => {
        threeSixtyViewerRef?.current?.removeEventListener(
          'fullscreenchange',
          handleExitViewerFullScreen
        );
        threeSixtyViewerRef?.current?.removeEventListener(
          'webkitfullscreenchange',
          handleExitViewerFullScreen
        );
      };
    }, [threeSixtyViewerRef.current]);

    const handleDownloadThreeSixtyImagesZip = () => {
      var zip = new JSZip();
      const zipName = productInfo?.name;
      if (productImages?.length) {
        let count = 0;
        productImages.forEach(function (imgObj, i) {
          let url = imgObj.image_file;
          let ext = imgObj.image_file.split('.').pop().split('?')[0];
          let filename = `${zipName}_${i}.${ext}`;
          JSZipUtils.getBinaryContent(url, function (err, data) {
            if (err) {
              throw err; // or handle the error
            }
            zip.file(filename, data, { binary: true });
            count++;
            if (count === productImages.length) {
              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipName);
                count = 0;
              });
            }
          });
        });
      }
    };
    return (
      <Row className="g-lg-5 mb-4 product-row">
        {/* Show case Block */}
        <Col lg={6}>
          <div
            className="product-image text-center"
            style={{ width: 'fit-content', height: '100%' }}
            ref={threeSixtyViewerRef}>
            {editFlag && !loaderValue && isEditor && (
              <UploadThreeSixtyImage
                bigBtnClass="lf-btn-1"
                buttonTitle=""
                handleCloseModal={toggleEdit}
                productId={productInfo?.id}
                iconBefore={<UploadFileIcon />}
              />
            )}
            {productImages && productImages?.length > 23 ? (
              <>
                <React360
                  numImages={productImages?.length}
                  productImages={productImages?.map((list) => list?.image_file) || []}
                  isFullscreen={viewerFullScreen}
                  setImageLoaded={setImageLoaded}
                />

                {imageLoaded ? (
                  <>
                    <span className="drag-rotate">
                      <ThreeSixtyIcon /> <span>Click and drag to rotate</span>
                    </span>

                    {!viewerFullScreen && !isGuestUser() && !isGuestLogin ? (
                      <ShareButton
                        className="share_button"
                        menuClassName="me-auto"
                        style={{
                          position: 'absolute',
                          bottom: '1rem',
                          left: '0.75rem',
                        }}
                        onClick={
                          isPublicPage && !currentUser
                            ? () => navigate(SIGN_IN_ROUTE) // SIGNUP_ROUTE // Commenting this code to prevent signup
                            : productInfo?.product_viewer_status || pdpArViewerCount
                              ? null
                              : (!activePlan && available3DViewerCount === 0) ||
                                  available3DViewerCount === 0
                                ? isPackProduct
                                  ? null
                                  : handleShareForUse
                                : null
                        }
                        menu={actionMenu}
                      />
                    ) : null}

                    {/* Download all the images in zip*/}
                    {(isInternalUser() || hasPermission(PERMISSION.PDP_360_IMAGE_DOWNLOAD)) &&
                      !viewerFullScreen && (
                        <div
                          className="download-icon"
                          title="Download Images"
                          onClick={handleDownloadThreeSixtyImagesZip}>
                          <DownloadArrowIcon />
                        </div>
                      )}
                    {/* View viewer in full screen */}
                    <div
                      className="fullscreen-icon"
                      onClick={() =>
                        handleToggleScreen(threeSixtyViewerRef.current, setViewerFullScreen)
                      }>
                      {viewerFullScreen ? <MdOutlineCloseFullscreen /> : <FullScreenIcon />}
                    </div>
                  </>
                ) : null}
              </>
            ) : !loaderValue &&
              (data?.thumbnail || data?.product_file || productImages[0]?.image_file > 0) ? (
              <img
                src={data?.thumbnail || data?.product_file || productImages[0]?.image_file}
                alt={data?.name}
              />
            ) : (
              !loaderValue && (
                <div style={{ height: '64px', width: '64px' }}>
                  <img
                    src={Logo}
                    style={{
                      position: 'absolute',
                      height: '64px',
                      width: '64px',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              )
            )}
          </div>
        </Col>
        <Col lg={6}>
          <div className="product-info mt-3 mt-lg-0">
            <h3 className={`mb-0 ${!editFlag ? 'ms-1' : ''}`}>
              {editFlag ? (
                <input
                  className={`form-control ${editFlag ? 'input-bg-color' : ''}`}
                  value={productInfo?.name}
                  type="text"
                  readOnly={!editFlag}
                  onChange={(e) => handleOnChange('name', e)}
                />
              ) : (
                productInfo?.name || ''
              )}
            </h3>
            {error?.name && <span className="error-text-red">{error?.name}</span>}
            {editFlag && (
              <textarea
                className={`form-control ${editFlag ? 'input-bg-color' : ''}`}
                readOnly={!editFlag}
                rows={4}
                placeholder={editFlag ? defaultProductDescription : ''}
                onChange={(e) => handleOnChange('description', e)}
                value={
                  productInfo?.description || editFlag
                    ? productInfo?.description || ''
                    : defaultProductDescription
                }></textarea>
            )}
            {!editFlag && <pre>{productInfo?.description || defaultProductDescription}</pre>}

            <div className="product-detail-box">
              <span className="infoText">
                {`The details shown below are sample values for demonstration purposes only and can be replaced with your actual product information.`}
              </span>
              <table className="table">
                <tbody>
                  <tr>
                    <td>Price</td>
                    <td>
                      <input
                        className={`form-control ${editFlag ? 'input-bg-color' : ''}`}
                        value={
                          !productInfo?.price
                            ? editFlag
                              ? ''
                              : `$${defaultProductPrice}`
                            : `${editFlag ? '' : '$'}${productInfo?.price}`
                        }
                        placeholder={editFlag ? defaultProductPrice : ''}
                        onChange={(e) => handleOnChange('price', e)}
                        readOnly={!editFlag}
                      />
                      {error?.price && <span className="error-text-red">{error?.price}</span>}
                    </td>
                  </tr>
                  <tr>
                    <td>SKU ID</td>
                    <td>
                      <input
                        className={`form-control ${editFlag ? 'input-bg-color' : ''}`}
                        value={
                          productInfo?.sku_id && productInfo?.sku_id !== 'null'
                            ? productInfo?.sku_id
                            : editFlag
                              ? ''
                              : '-'
                        }
                        placeholder={
                          editFlag
                            ? getDefaultSKU({ id: productInfo?.id, name: productInfo?.name })
                            : ''
                        }
                        type="text"
                        onChange={(e) => handleOnChange('sku_id', e)}
                        readOnly={!editFlag}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Dimensions</td>
                    <td>
                      <input
                        className={`form-control ${editFlag ? 'input-bg-color' : ''}`}
                        value={
                          editFlag
                            ? productInfo?.dimensions
                            : productInfo?.dimensions
                              ? getDimension(productInfo?.dimensions)
                              : defaultDimension
                        }
                        placeholder={editFlag ? defaultDimension : ''}
                        type="text"
                        onChange={(e) => handleOnChange('dimensions', e)}
                        readOnly={!editFlag}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* AR viewer */}
            {publicRealProductId && data?.glb_file && (
              <ARViewButton
                isPublicPage={isPublicPage}
                propId={publicRealProductId}
                propName={productInfo?.name}
                productInfo={productInfo}
                refetchDetails={refetchDetails}
                productUnicodeId={productUnicodeId}
                orgProductUniqueCodeId={orgProductUniqueCodeId}
                loading={loading}
                isPackProduct={isPackProduct}
              />
            )}

            {/* filters */}
            {/* {!editFlag &&
            productInfo?.id &&
            (productFilters?.length || productInfo?.tags?.length) &&
            handleLoadTagsAndCategory()?.length > 0 && (
              <div className="d-flex flex-wrap pt-1 mb-2">
                {handleLoadTagsAndCategory()?.map((list) => {
                  return (
                    <Button color="dark" size="xlg" className="so-icon-button me-2 mb-2">
                      {list?.label || list}
                    </Button>
                  );
                })}
              </div>
            )}
          {productInfo &&
            editFlag &&
            productFilters?.map((filter, index) => {
              const { fieldsConfig } = getCategoryFields(filter, getFilterValue(filter.id));
              return (
                <div key={index}>
                  {(fieldsConfig?.[0]?.value && fieldsConfig?.[0]?.value?.length) || editFlag ? (
                    <div className="life-style-header mt-0 mb-2">
                      <h6 class="sub-title">{filter?.label_name}</h6>
                    </div>
                  ) : null}

                  <div className="d-flex flex-wrap pt-1 mb-2">
                    {fieldsConfig &&
                      fieldsConfig[0]?.value?.map((list) => {
                        return (
                          <Button
                            color="dark"
                            size="xlg"
                            className="so-icon-button me-2 mb-2"
                            iconAfter={
                              editFlag ? (
                                <CancelIcon
                                  color="#fff"
                                  onClick={() => handleRemoveCategory(list)}
                                />
                              ) : (
                                ''
                              )
                            }>
                            {list?.label}
                          </Button>
                        );
                      })}

                    {error?.category && +filter?.id === PRODUCT_CATEGORY_VALUE.CATEGORY && (
                      <span className="error-text-red">{error?.category}</span>
                    )}
                    {error?.subCategory && +filter?.id === PRODUCT_CATEGORY_VALUE.SUB_CATEGORY && (
                      <span className="error-text-red">{error?.subCategory}</span>
                    )}
                  </div>
                  {editFlag && (
                    <>
                      {!addButtonActive.category &&
                        +filter?.id === PRODUCT_CATEGORY_VALUE.CATEGORY && (
                          <Button
                            color="light"
                            onClick={() => {
                              handleShowInput('category', !addButtonActive['category']);
                            }}
                            size="xlg "
                            className="so-icon-button mb-2 text-black"
                            iconBefore={<AddPlusIcon />}>
                            {' '}
                            Add
                          </Button>
                        )}
                      {!addButtonActive.subCategory &&
                        +filter?.id === PRODUCT_CATEGORY_VALUE.SUB_CATEGORY && (
                          <Button
                            color="light"
                            onClick={() => {
                              handleShowInput('subCategory', !addButtonActive['subCategory']);
                            }}
                            size="xlg "
                            className="so-icon-button mb-2 text-black"
                            iconBefore={<AddPlusIcon />}>
                            {' '}
                            Add
                          </Button>
                        )}

                      {addButtonActive.category &&
                        +filter?.id === PRODUCT_CATEGORY_VALUE.CATEGORY && (
                          <StyledSelect
                            onChange={(e) =>
                              handleAddCategoryAndSubCategory(e, {
                                filter_label: +filter?.id,
                              })
                            }
                            isSearchable
                            options={handleLoadCategoryOption(filter?.options) || []}
                            placeholder="Select Category"
                            className="mb-2"
                            onMenuScrollToBottom={(e) => handleNext()}
                          />
                        )}
                      {addButtonActive.subCategory &&
                        +filter?.id === PRODUCT_CATEGORY_VALUE.SUB_CATEGORY && (
                          <StyledSelect
                            onChange={(e) =>
                              handleAddCategoryAndSubCategory(e, {
                                filter_label: +filter?.id,
                              })
                            }
                            isSearchable
                            options={handleLoadCategoryOption(filter?.options) || []}
                            placeholder="Select SubCategory"
                            className="mb-2"
                          />
                        )}
                    </>
                  )}
                </div>
              );
            })}

          {editFlag && (
            <div>
              {(productInfo?.tags && productInfo?.tags?.length) || editFlag ? (
                <div className="life-style-header mt-0 mb-2">
                  <h6 className="sub-title">Tags</h6>
                </div>
              ) : null}
              <div className="d-flex flex-wrap pt-1 mb-2">
                {productInfo?.tags &&
                  productInfo?.tags?.map((tag, index) => {
                    return (
                      <Button
                        color="dark"
                        size="xlg"
                        className="so-icon-button me-2 mb-2"
                        iconAfter={
                          editFlag ? (
                            <CancelIcon color="#fff" onClick={() => handleRemoveTag(index)} />
                          ) : (
                            ''
                          )
                        }>
                        {tag?.label || tag}
                      </Button>
                    );
                  })}
                {error?.tags && <span className="error-text-red">{error?.tags}</span>}
              </div>
              {editFlag && (
                <>
                  {!addButtonActive.tags && (
                    <Button
                      color="light"
                      onClick={() => {
                        handleShowInput('tags', !addButtonActive.tags);
                      }}
                      size="xlg"
                      className="so-icon-button mb-2 text-black"
                      iconBefore={<AddPlusIcon />}>
                      {' '}
                      Add
                    </Button>
                  )}

                  {addButtonActive.tags && (
                    <StyledSelect
                      onChange={handleAddTag}
                      isSearchable
                      options={handleLoadOptions(tagsList)}
                      placeholder="Select Tag"
                      onInputChange={(e) => {
                        handleSearchOrg && handleSearchOrg(e);
                      }}
                      className="mb-2"
                      onMenuScrollToBottom={(e) => handleNext()}
                    />
                  )}
                </>
              )}
            </div>
          )} */}
          </div>
        </Col>
      </Row>
    );
  }
);
